import { render } from "./ZhaiJiuGong.vue?vue&type=template&id=f1798a20&scoped=true"
import script from "./ZhaiJiuGong.vue?vue&type=script&lang=js"
export * from "./ZhaiJiuGong.vue?vue&type=script&lang=js"

import "./ZhaiJiuGong.vue?vue&type=style&index=0&id=f1798a20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1798a20"]])

export default __exports__